import { Button, Grid, TextField } from '@mui/material';
import { FormikValues } from 'formik';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../../dialogs';
import { useAttestationAbsent } from './useAttestationAbsent';

interface AttestationAbsentDialogProps {
  title?: string;
  text?: string;
  popDialog?: any;
  onSubmit: (values: FormikValues) => void;
}

export const AttestationAbsentDialog: ComponentType<AttestationAbsentDialogProps> = ({
  title: dialogTitle,
  text,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const { formik, hasError, getErrorMessage } = useAttestationAbsent({
    onSubmit,
  });

  const title = dialogTitle ? dialogTitle : t('attestation.absent.reason', 'Причина неявки');

  return (
    <BaseDialog {...{ ...props, popDialog, title }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container mb={4} direction="column" spacing={1}>
          <Grid item>
            <TextField
              {...formik.getFieldProps('explanation')}
              // onChange={(e: any) => handleFieldChange('explanation', e)}
              error={hasError('explanation')}
              helperText={getErrorMessage('explanation')}
              label={t('attestation.absent.reason.label', 'Причина неявки сотрудника')}
              placeholder={t('attestation.absent.reason.placeholder', 'Введите причину...')}
              fullWidth
              multiline
              rows={4}
            />
          </Grid>
        </Grid>
        <Grid container columnSpacing={2} justifyContent="flex-end">
          <Grid item xs={6}>
            <Button
              onClick={popDialog}
              variant="outlined"
              color="inherit"
              size="large"
              fullWidth
              sx={{ minWidth: 0 }}
            >
              {t('cancel', 'Отмена')}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              variant="contained"
              color="secondary"
              size="large"
              fullWidth
              sx={{ minWidth: 0 }}
            >
              {t('action.send', 'Отправить')}
            </Button>
          </Grid>
        </Grid>
      </form>
    </BaseDialog>
  );
};
